import { posthog } from 'posthog-js';

import { FEATURE_FLAGS } from './feature-flagging.consts';

/**
 * Non-hook flag read, for route guards that run outside React.
 *
 * Matches `usePosthogFeatureFlag`: an unresolved flag reads as `false` rather
 * than blocking. PostHog is ad-blockable, so waiting for a value that may never
 * arrive would hang navigation.
 */
export function isFeatureFlagEnabled(
  flagKey: keyof typeof FEATURE_FLAGS | (string & {})
): boolean {
  try {
    return posthog.isFeatureEnabled(flagKey) ?? false;
  } catch {
    return false;
  }
}
